import {getPrefix, getSessionToken} from "../../lib/bandung/bandung";
import Axios from "axios";
import {reformatEvents} from "../../util/helpers/eventHelper";
import {objectToFormData} from "../../lib/bandung/api/helpers";

const getEventPrefix = () => `${getPrefix()}/app/event`;

const getEventViewEndPoint = (eventEntityId) => `${getEventPrefix()}/view?eventEntityId=${eventEntityId}`
const getEventListPreviousEndPoint = () => `${getEventPrefix()}/listprevious`;
const getEventListPendingEndPoint = () => `${getEventPrefix()}/listunapproved`;
const getEventListUpcomingEndPoint = () => `${getEventPrefix()}/listfuture`;
const getEventTextShortDescriptionEndPoint = (eventEntityId) => `${getEventPrefix()}/textshortdescription?eventEntityId=${eventEntityId}`
const getEventCreateEndPoint = () => `${getEventPrefix()}/create`;
const getEventUpdateEndPoint = () => `${getEventPrefix()}/update`;
const getEventUpdateShortDescriptionEndPoint = () => `${getEventPrefix()}/updateshortdescription`;

const eventListUpcoming = async () => {
    try {
        const response = await Axios.get(getEventListUpcomingEndPoint());
        if (!response.data.error) {
            console.log("data:", response.data)
            return {
                code: "SUCCESS",
                message: "Upcoming events loaded successfully",
                data: reformatEvents(response.data),
            };
        } else {
            throw new Error(response.data.error);
        }
    } catch (error) {
        return {
            code: "ERROR",
            message: error.message || "An error occurred.",
        };
    }
};

const eventListPrevious = async () => {
    try {
        const response = await Axios.get(getEventListPreviousEndPoint());
        if (!response.data.error) {
            console.log("data prev:", response.data)
            return {
                code: "SUCCESS",
                message: "Previous events loaded successfully",
                data: reformatEvents(response.data),
            };
        } else {
            throw new Error(response.data.error);
        }
    } catch (error) {
        return {
            code: "ERROR",
            message: error.message || "An error occurred.",
        };
    }
};

const eventListPending = async () => {
    try {
        const response = await Axios.get(getEventListPendingEndPoint());
        if (!response.data.error) {
            return {
                code: "SUCCESS",
                message: "Pending events loaded successfully",
                data: response.data,
            };
        } else {
            throw new Error(response.data.error);
        }
    } catch (error) {
        return {
            code: "ERROR",
            message: error.message || "An error occurred.",
        };
    }
};

const eventCreate = async ({
                               label,
                               startDate,
                               endDate,
                               startTime,
                               endTime,
                               shortDescription,
                               eventTypeEntityId,
                           }) => {
    const form = objectToFormData({
        sessionToken: getSessionToken(),
        label,
        startDate,
        endDate,
        startTime,
        endTime,
        shortDescription,
        eventTypeEntityId,
    });

    try {
        const response = await Axios.post(getEventCreateEndPoint(), form);
        if (!response.data.error) {
            return {
                code: "SUCCESS",
                message: "You have successfully create the event with Event Id: " +
                    response.data.eventEntityId,
                data: {eventEntityId: response.data.eventEntityId},
            };
        } else {
            throw new Error(response.data.error);
        }
    } catch (error) {
        return {
            code: "ERROR",
            message: error.message || "An error occurred.",
        };
    }
};

const eventView = async (eventEntityId) => {
    try {
        const response = await Axios.get(getEventViewEndPoint(eventEntityId));
        if (!response.data.error) {
            return {
                code: "SUCCESS",
                message: "Event loaded successfully",
                data: response.data,
            };
        } else {
            throw new Error(response.data.error);
        }
    } catch (error) {
        return {
            code: "ERROR",
            message: error.message || "An error occurred.",
        };
    }
}

const eventUpdate = async ({
                               eventEntityId,
                               label,
                               startDate,
                               endDate,
                               startTime,
                               endTime,
                               eventTypeEntityId,
                           }) => {
    const form = objectToFormData({
        sessionToken: getSessionToken(),
        eventEntityId,
        label,
        startDate,
        endDate,
        startTime,
        endTime,
        eventTypeEntityId,
    });
    try {
        const response = await Axios.post(getEventUpdateEndPoint(), form);
        if (!response.data.error) {
            return {
                code: "SUCCESS",
                message: "Event Update successful.",
            };
        } else {
            throw new Error(response.data.error);
        }
    } catch (error) {
        return {
            code: "ERROR",
            message: error.message || "An error occurred.",
        };
    }
};

const eventTextShortDescription = async (id) => {
    try {
        const response = await Axios.get(getEventTextShortDescriptionEndPoint(id));
        if (!response.data.error) {
            return {
                code: "SUCCESS",
                message: "Event Short Description loaded successfully",
                data: response.data,
            }
        } else {
            throw new Error(response.data.error);
        }
    } catch (error) {
        return {
            code: "ERROR",
            message: error.message || "An error occurred.",
        };
    }
}

const eventUpdateShortDescription = async (
    eventEntityId, shortDescription) => {
    const form = objectToFormData({
        sessionToken: getSessionToken(),
        eventEntityId,
        shortDescription,
    });
    try {
        const response = await Axios.post(
            getEventUpdateShortDescriptionEndPoint(),
            form);
        if (response.data.entity) {
            return {
                code: "SUCCESS",
                message: "Short description updated successfully.",
            };
        } else {
            throw new Error(response.data.error);
        }
    } catch (error) {
        return {
            code: "ERROR",
            message: error.message || "An error occurred.",
        };
    }
};

export {
    eventListUpcoming,
    eventListPrevious,
    eventListPending,
    eventCreate,
    eventView,
    eventUpdate,
    eventTextShortDescription,
    eventUpdateShortDescription
};
